import { STATIC_IMAGE_URLS } from 'modules/core/constants';
import { useTranslation } from 'react-i18next';
import React, { useCallback, useState } from 'react';

import { ForgotPasswordForm } from './ForgotPasswordForm';
import {
  PositionCard,
  CardForm,
  CardImage,
  CardTitle,
  CardBody,
  LoginContent,
  BackgroundLayer,
  DecorativeLayer,
  LoginHeader,
  HeaderLogo,
  ForgotPasswordFormPosition,
  TextForgotPassword,
} from '../styles';
import { Button } from '../common';

const { logoDark, logoWhite } = STATIC_IMAGE_URLS;

export const ForgotPassword: React.FC = () => {
  const { t } = useTranslation();
  const [isEmailExist, setIsEmailExist] = useState(false);

  const showLinkIsSentContent = useCallback(() => {
    setIsEmailExist(true);
  }, [setIsEmailExist]);

  return (
    <>
      <LoginHeader>
        <HeaderLogo src={logoWhite} alt="Streamline Logo" />
      </LoginHeader>
      <BackgroundLayer />
      <DecorativeLayer />
      <LoginContent>
        <PositionCard>
          <CardForm>
            <CardImage src={logoDark} />
            {isEmailExist ? (
              <CardBody>
                <ForgotPasswordFormPosition>
                  <CardTitle>{t('components.resetPassword.linkIsSent')}</CardTitle>
                  <TextForgotPassword>{t('components.resetPassword.checkEmailLineOne')}</TextForgotPassword>
                  <Button label={t('components.login.buttons.backToLogin')} isOnClick />
                </ForgotPasswordFormPosition>
              </CardBody>
            ) : (
              <>
                <CardBody>
                  <ForgotPasswordForm onShowLinkIsSentContent={showLinkIsSentContent} />
                </CardBody>
              </>
            )}
          </CardForm>
        </PositionCard>
      </LoginContent>
    </>
  );
};
